import { CitiesService } from './../../../services/cities/cities.service';
import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { UserService } from '../../../services/user/user.service';
import { HelperService } from 'src/app/services/helper/helper.service';
import { ErrorMonitoringService } from 'src/app/services/error-monitoring/error-monitoring.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import * as moment from 'moment-timezone';

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },

};

@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.page.html',
  styleUrls: ['./user-detail.page.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' }
  ],
})
export class UserDetailPage implements OnInit {

  @Input() userData: any;
  @Input() newBeneficiary: any;

  private uploadDocument: any = null;
  private uploadImageProfile: any = null;
  /**
   * @required true
   * @default {false} -> Permite cerrar esta ventana modal
   * @description Bandera para identificar si ya fue solicitado el cierre de esta ventana modal
   *
   * @private
   * @type {boolean}
   * @memberof UserDetailPage
   */
  private isClosed: boolean = false;

  /**
   * @required true
   * @default {false} -> Indica que no se ha cargado imagen para el beneficiario 
   * @description Bandera que indica cuando se ha cargado una imagen para el beneficiario
   *
   * @memberof UserDetailPage
   */
  showNewProfile = false;
  newDocument = false;
  available = false;
  profileImage: any = null;
  stepNumber = 0;
  minDate = moment().subtract(110, 'y').format();
  maxDate = moment().format();
  cities = [];
  /**
   * @required true
   * @default {false} -> Des-habilita el botón de guardar colocando un texto de "guardando"
   * @description Habilita o des-habilita el botón de guardar
   *
   * @memberof UserDetailPage
   */
  savingData = false;

  constructor(
    private modalController: ModalController,
    private userService: UserService,
    private helperService: HelperService,
    private errorMonitoringService: ErrorMonitoringService,
    private citiesService: CitiesService
  ) {
    this.citiesService.getCitiesByCountry('COL').subscribe( cities => {
      this.cities = cities;
    }, error => {
      console.error(error);
    });
  }

  ngOnInit() {  }

  /**
   * @description Crea un beneficiario relacionado con el cliente actualmente logueado
   *
   * @author Alejandro Rangel Moreno <erangel@asesoftware.com>
   * @date 2020-05-27
   * @returns Mensaje de alerta con el usuario creado
   * @memberof UserDetailPage
   */
  private createBeneficiary() {
    if (!this.validateFields()) return;
    // des-habilita el botón de guardado mientra se ejecuta la acción de guardar.
    this.savingData = true;
    // Completa la data de usuario
    this.userData.active = true;
    // Completa la data de usuario
    this.userData.birthday = moment(this.userData.birthday).tz('America/Bogota').format('YYYY-MM-DD');
    // guarda el beneficiario
    this.userService.addBeneficiary(this.userData).then(async (userReference) => {
      // Completa la data con el id
      this.userData.id = userReference.id;
      this.helperService.presentMessageAlert('Beneficiario creado con éxito!', '', '', 'beneficiario-creado');
      // Cierra el modal actual
      this.closeModalBeneficiaryDetail();
    }).catch(err => {
      this.savingData = false;
      this.errorMonitoringService.sendError(err, 'addBeneficiary');
      this.helperService.presentMessageAlert('Mensaje', 'No se ha guardado el beneficiario, inténtalo de nuevo');
    });
  }

  /**
   * @description Actualiza la información de un beneficiario
   *
   * @author Alejandro Rangel Moreno <erangel@asesoftware.com>
   * @date 2020-05-27
   * @private
   * @param {boolean} [fromCreate=false]
   * @memberof UserDetailPage
   */
  private async updateBeneficiary(fromCreate: boolean = false) {
    if (!this.userData.id) this.helperService.presentMessageAlert('Alerta', 'Se requiere primero crear el beneficiario.')

    if (this.userData.birthday) this.userData.birthday = moment(this.userData.birthday).tz('America/Bogota').format('YYYY-MM-DD');

    /* Actualiza la info del beneficiario */
    this.savingData = true;
    this.userService.updateBeneficiary(this.userData.id, this.userData).then(() => {
      this.closeModalBeneficiaryDetail();
      this.helperService.presentMessageAlert('Beneficiario actualizado con éxito!', '', '', 'beneficiario-creado');
    }).catch(err => {
      this.savingData = false;
      this.errorMonitoringService.sendError(err, 'updateBeneficiary');
      this.helperService.presentMessageAlert('Mensaje', 'No se ha actualizado el beneficiario, inténtalo de nuevo');
    });
  }

  /**
   * @description Método que evalúa la acción que se esta realizando
   *
   * @author Alejandro Rangel Moreno <erangel@asesoftware.com>
   * @date 2020-05-27
   * @returns {any}
   * @memberof UserDetailPage
   */
  validateAction() {
    if (!this.userData.id) return this.createBeneficiary();
    if (this.validateFields()) return this.updateBeneficiary();
  }

  /**
   * @description Funcionalidad para el botón regresar de la cabecera. Cierra el éste modal.
   *
   * @author Mayvi Eliana Ocampo <mocampo@asesoftware.com>
   * @date 2020-04-11
   * @memberof UserDetailPage
   */
  closeModalBeneficiaryDetail() {
    this.isClosed = true;
    this.modalController.dismiss('cerrar');
  }

  /**
   * @description Realiza la validación de la información personal para habilitar o des-habilitar el
   * botón de guardar
   *
   * @author Marco Casallas <mcasallas@asesoftware.com>
   * @date 2020-05-05
   * @returns {boolean}
   * @memberof UserDetailPage
   */
  validateFields(): boolean {
    /* si no hay nombres */
    if (!this.userData.name || (this.userData.name && this.userData.name === '')) {
      this.helperService.presentMessageAlert('Mensaje', 'Ingresa un nombre valido');
      return false;
    }
    if (!this.userData.surname || (this.userData.surname && this.userData.surname === '')) {
      this.helperService.presentMessageAlert('Mensaje', 'Ingresa un apellido valido');
      return false;
    }
    if (!this.userData.gender || (this.userData.gender && this.userData.gender !== 'M' && this.userData.gender !== 'H')) {
      this.helperService.presentMessageAlert('Mensaje', 'Selecciona el genero');
      return false;
    }
    if (!this.userData.documentType || (this.userData.documentType && this.userData.documentType === '')) {
      this.helperService.presentMessageAlert('Mensaje', 'Selecciona el tipo de documento');
      return false;
    }
    if (!this.userData.document || (this.userData.document && this.userData.document.length < 5)) {
      this.helperService.presentMessageAlert('Mensaje', 'Ingresa un documento valido');
      return false;
    }
    if (!this.userData.role || (this.userData.role && this.userData.role === '')) {
      this.helperService.presentMessageAlert('Mensaje', 'Selecciona un parentesco');
      return false;
    }
    if (!this.userData.city || (this.userData.city && this.userData.city === '')) {
      this.helperService.presentMessageAlert('Mensaje', 'Selecciona una ciudad');
      return false;
    }
    if (!this.userData.birthday || this.userData.birthday && this.userData.birthday === '') {
      this.helperService.presentMessageAlert('Mensaje', 'Selecciona una fecha de cumpleaños');
      return false;
    }
    if (!this.userData.mobile || this.userData.mobile && this.userData.mobile.toString().length !== 10) {
      this.helperService.presentMessageAlert('Mensaje', 'Ingresa un celular valido');
      return false;
    }
    return true;
  }

}
